import { render } from "./MarcheOpportunites.vue?vue&type=template&id=7270351e"
import script from "./MarcheOpportunites.vue?vue&type=script&lang=js"
export * from "./MarcheOpportunites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__